import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { MyContext, ListContext } from "./MyContext";

import { valueFromId } from "./momentUtils";
import { customColors } from "./styleConstants";
// import AuthHelperMethods from "./AuthHelperMethods";
import Auth from "./Auth";

const SelectInstructor = (props) => {
  const { mystate, dispatch } = useContext(MyContext);
  const [active, setActive] = useState(true);
  const [options, setOptions] = useState();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(
    () => {
      const fetchData = async () => {
        //  let params = { is_active: active ? 1 : 0 };

        console.log("**************** INSTRUCTOR FETCH *****************");
        try {
          const result = await Auth.api("instructors/index", "get");
          let options = result.data.options.map((option) => ({
            ...option,
            color: option.color_code,
          }));
          console.log(options);
          dispatch({
            type: "GET_INSTRUCTOR_OPTIONS",
            options: options,
          });

          //  setOptions(map_options_instructor(result.data.instructors));
        } catch (error) {
          console.log("error");
        }
      };

      fetchData();
    },
    //eslint-disable-next-line
    [],
  );

  const handleInstructorChangeAdd = (event) => {
    dispatch({
      type: "SET_NEW_EVENT",
      data: { instructor_id: event.value },
    });
  };

  const handleInstructorChangeEdit = (event) => {
    //console.log("handleInstructorChangeEdit");
    //console.log(event);

    let d = valueFromId(mystate.options_instructor, event.value);
    console.log(d);
    dispatch({
      type: "EDIT_CURRENT_INSTRUCTOR",
      data: d,
    });
  };
  function onClickActive() {
    setActive(!active);
  }
  //  const instructor_id = props.instructor_id || mystate.addevent.instructor_id;

  const [group, setGroup] = useState("all");

  const all = mystate.options_instructor || [];
  const instructors = all.filter((opt) => opt.is_instructor);
  const volunteers = all.filter((opt) => opt.is_volunteer);
  const barnstaff = all.filter((opt) => opt.is_barnstaff);

  const filtered =
    group === "volunteers"
      ? volunteers
      : group === "barnstaff"
        ? barnstaff
        : group === "instructors"
          ? instructors
          : all;

  const groupOptions = [
    { label: "all", value: "all" },
    { label: "volunteer", value: "volunteers" },
    { label: "barn", value: "barnstaff" },
    { label: "instructor", value: "i" },
  ];

  return (
    <>
      {instructors.length > 0 && (
        <div className="selectInstructor">
          <div style={{ marginBottom: 12, display: "flex", gap: 8 }}>
            {groupOptions.map((opt) => (
              <button
                key={opt.value}
                type="button"
                onClick={() => {
                  setGroup(opt.value);
                  //(true);
                }}
                style={{
                  padding: "6px 16px",
                  borderRadius: 5,
                  border:
                    group === opt.value
                      ? `2px solid ${customColors.COLORS?.blue || "#0099BC"}`
                      : "1px solid #ccc",
                  background:
                    group === opt.value
                      ? customColors.COLORS?.blue || "#0099BC"
                      : "#f7f7f7",
                  color: group === opt.value ? "#fff" : "#333",
                  fontWeight: group === opt.value ? 700 : 400,
                  cursor: "pointer",
                  outline: "none",
                  transition: "all 0.15s",
                  boxShadow:
                    group === opt.value ? "0 2px 8px #ff980033" : "none",
                }}
              >
                {opt.label}
              </button>
            ))}
          </div>
          <Select
            onChange={(event) => {
              if (props.addOrEdit == "add") {
                handleInstructorChangeAdd(event);
              }
              if (props.addOrEdit == "edit") {
                handleInstructorChangeEdit(event);
              }
              if (props.onStaffTaskEdit) {
                props.onStaffTaskEdit(event);
              }
            }}
            value={filtered.filter(
              (option) =>
                option.value ==
                (props.addOrEdit == "add"
                  ? mystate.addevent.instructor_id
                  : mystate.currentLesson.instructor_id),
            )}
            options={filtered}
            clearable={true}
            searchable={false}
            placeholder={"Select Staff..."}
            styles={customColors}
            menuPlacement="auto"
          />
        </div>
      )}
    </>
  );
};

export default SelectInstructor;
